import styled from "styled-components";

export const BrasiliaInfoBasica = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: -7px;
`;

export const SelectContainer = styled.div`
    flex: 1;
    padding-left: 10px;
`;

export const InputContainer = styled.div`
    flex: 1;
    padding-left: 10px;
    
    .default-input {
        min-height: auto;
        margin-top: 0;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s ease;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
`;